import { render, staticRenderFns } from "./compny-person-icon.vue?vue&type=template&id=50784774"
import script from "./compny-person-icon.vue?vue&type=script&lang=js"
export * from "./compny-person-icon.vue?vue&type=script&lang=js"
import style0 from "./compny-person-icon.vue?vue&type=style&index=0&id=50784774&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports